import React from 'react';

const ZoomVerify = () => {
  return <div>a75d29dd90984b2585aeb25b480ea760</div>;
};

export default ZoomVerify;
